export const ResourcePathApi = async () => {
  const response = await fetch("/resources/config.json");
  const results = await response.json();
  return results;
};
